<div class="flex flex-col flex-nowrap justify-start items-start w-full gap-4">
  <div class="flex flex-row flex-nowrap justify-between items-center w-full">
    <p class="text-xl text-left">Projects</p>
    <div class="flex flex-row flex-nowrap justify-start items-center gap-4">
      <button mat-raised-button (click)="handleOnClickAddHours()">+ Add Hours</button>

      @if (!isExpandedUser) {
        <button mat-raised-button (click)="isExpandedUser = true">Expand All</button>
      } @else {
        <button mat-raised-button (click)="isExpandedUser = false">Collapse All</button>
      }
    </div>
  </div>

  <app-project-filters class="w-full"></app-project-filters>

  <mat-accordion multi class="w-full">
    @for (project of filteredProjects; track project.projectNo) {
      <mat-expansion-panel [expanded]="isExpanded">
        <mat-expansion-panel-header>
          <mat-panel-title class="w-full">
            <span class="block truncate" [innerHTML]="project.projectNo + ' - ' + project.projectName | highlight: _projectFeature.searchText()"></span>
          </mat-panel-title>
          <mat-panel-description class="w-full">
            <p class="line-clamp-2">
              {{ project.projectDescription }}
            </p>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <app-phases [projectNo]="project.projectNo"></app-phases>
      </mat-expansion-panel>
    } @empty {
      @if (_projectFeature.isLoadingProjects() || _projectFeature.isLoadingPhases() || _projectFeature.isLoadingTasks()) {
        <div class="w-full flex justify-center items-center pt-[20px]">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        <div class="w-full flex justify-center items-center pt-[20px]">
          <p class="text-lg">No projects added.</p>
        </div>
      }
    }
  </mat-accordion>
</div>
